export const ARTICLE_ID = 'ARTICLE_ID'
export const FETCH_ALL = 'FETCH_ALL'
export const CURRENT_ID = 'CURRENT_ID'
export const DELETE = 'DELETE'
export const ID_FOR_DELETE = 'ID_FOR_DELETE'
export const IS_LOGGED_IN = 'IS_LOGGED_IN'
export const CURRENT_PAGE_HOME = 'CURRENT_PAGE_HOME'
export const CURRENT_PAGE_MOBILE = 'CURRENT_PAGE_MOBILE'
export const CURRENT_PAGE_COMPUTER = 'CURRENT_PAGE_COMPUTER'
export const CURRENT_PAGE_SCIENCE = 'CURRENT_PAGE_SCIENCE'
export const CURRENT_PAGE_SEARCH = 'CURRENT_PAGE_SEARCH'
export const CURRENT_PAGE_DASHBOARD = 'CURRENT_PAGE_DASHBOARD'
export const IS_LOADING = 'IS_LOADING'
